import React, { PropsWithChildren, useMemo, useState } from 'react'

interface IProps {
  email: string,
  setEmail: (email: string) => void,
  token: string,
  setToken: (token: string) => void,
  twoFactorMethod: number,
  setTwoFactorMethod: (twoFactorMethod: number) => void,
  rememberMe: boolean,
  setRememberMe: (remember: boolean) => void,
  refreshToken: string,
  setRefreshToken: (token: string) => void,
  longTermToken: string,
  setLongTermToken: (token: string) => void,
  displayName: string,
  setDisplayName: (name: string) => void,
}

export const AuthContext = React.createContext<IProps>({
  email: '',
  setEmail: (email: string) => { },
  token: '',
  setToken: (token: string) => { },
  twoFactorMethod: 0,
  setTwoFactorMethod: (token: number) => { },
  rememberMe: false,
  setRememberMe: (remember: boolean) => { },
  refreshToken: '',
  setRefreshToken: (token: string) => { },
  longTermToken: '',
  setLongTermToken: (token: string) => { },
  displayName: '',
  setDisplayName: (name: string) => { },
})

export const AuthContextProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {

  const [email, setEmail] = useState<string>('');
  const [token, setToken] = useState<string>('');
  const [twoFactorMethod, setTwoFactorMethod] = useState<number>(0);
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [refreshToken, setRefreshToken] = useState<string>('');
  const [longTermToken, setLongTermToken] = useState<string>('');
  const [displayName, setDisplayName] = useState<string>('');

  const value: IProps = useMemo(() => {
    return {
      email,
      setEmail,
      token,
      setToken,
      twoFactorMethod,
      setTwoFactorMethod,
      rememberMe,
      setRememberMe,
      refreshToken,
      setRefreshToken,
      longTermToken,
      setLongTermToken,
      displayName,
      setDisplayName,
    }
  }, [
    email,
    setEmail,
    token,
    setToken,
    twoFactorMethod,
    setTwoFactorMethod,
    rememberMe,
    setRememberMe,
    refreshToken,
    setRefreshToken,
    longTermToken,
    setLongTermToken,
    displayName,
    setDisplayName,
  ])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
